

import React, { useState } from "react";
import {
  Box,
  Typography,
  Collapse,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import * as MuiIcons from "@mui/icons-material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { motion } from "framer-motion"; 
import { useNavigate } from "react-router-dom";


export default function SidebarItem({ item, sidebarOpen, level, onItemClick }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const Icon = MuiIcons[item.icon] || MuiIcons["Circle"];
  const hasChildren = Array.isArray(item.children);

   
  const handleClick = () => {
    if (item.path) {
      navigate(item.path);
      onItemClick?.(); // 👈 auto close on mobile
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tooltip title={!sidebarOpen ? item.title : ""}
        placement="right">

        {/* MENU BUTTON */}
        <Box
         
          onClick={() => {
            if (hasChildren) {
              setOpen(!open);
            } else {
              handleClick();
            }
          }}

          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: sidebarOpen ? 1.5 : 1,
            py: 1,
            pl: sidebarOpen ? level * 1.5 + 1.2 : 1,
            borderRadius: 3,
            cursor: "pointer",

            /* keep fully transparent */
            background: "transparent !important",

            /* subtle glass hover */
            "&:hover": {
              background: isDark ? "rgba(255,255,255,0.08)" : "rgba(15,23,42,0.06)",
              boxShadow: isDark
                ? "0 0 12px rgba(255,255,255,0.15)"
                : "0 6px 16px rgba(15,23,42,0.08)",
              backdropFilter: "blur(8px)",
            },
            transition: "0.25s ease",
          }}
        >
          {/* LEFT GLOW LINE */}
          {sidebarOpen && (
            <Box
              sx={{
                width: 4,
                height: 22,
                borderRadius: 2,
                mr: 0.5,
                background: open
                  ? (isDark ? "rgba(255,255,255,0.4)" : "rgba(37,99,235,0.6)")
                  : "transparent",
                transition: "0.25s",
              }}
            />
          )}

          {/* ICON */}
          <Icon
            sx={{
              fontSize: 18,
              color: isDark ? "#f8fafc" : "#0f172a",
            }}
          />

          {/* TEXT */}
          {sidebarOpen && (
            <Typography
              component={motion.span}
              initial={{ opacity: 0, x: -4 }}
              animate={{ opacity: 1, x: 0 }}
              style={{
                color: isDark ? "#f8fafc" : "#0f172a",
                fontSize: 14-(level*2),
                fontWeight: open ? 600 : 500,
                whiteSpace: "nowrap",
              }}
            >
              {item.title}
            </Typography>
          )}

          {/* EXPAND ICON */}
          {hasChildren && sidebarOpen && (
            <IconButton
              size="small"

              sx={{
                color: isDark ? "#f8fafc" : "#0f172a",
                transform: open ? "rotate(180deg)" : "none",
                transition: "0.2s",
                p: 0.2,
              }}
            >
              <ExpandMore />
            </IconButton>
          )}
        </Box>

        {/* CHILDREN */}
        {hasChildren && (
          <Collapse in={open} timeout="auto"  >
            {item.children.map((child, i) => (
              <SidebarItem
                key={i}
                item={child}
                sidebarOpen={sidebarOpen}
                level={level + 1}
              />
            ))}
          </Collapse>
        )}
      </Tooltip>
    </Box>
  );
}
